<div class="aa-textarea-general gap-1 flex flex-col">
  <mat-label
    class="px-3 truncate"
    [title]="label | translate"
    [ngClass]="
      formControlGeneral?.invalid && (formControlGeneral?.touched || formControlGeneral?.dirty)
        ? 'text-(--comp-input-label-error)'
        : 'text-(--comp-input-label-normal)'
    "
  >
    {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
  </mat-label>

  <mat-form-field appearance="outline" class="w-full input-mat-form-field">
    <textarea
      [formControl]="formControlGeneral!"
      matInput
      [placeholder]="placeholder | translate"
    ></textarea>
    @if (formControlGeneral?.hasError('required')) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (formControlGeneral?.hasError('maxlength')) {
      <mat-error>
        {{
          'inputs.maxlength'
            | translate: { requiredLength: formControlGeneral?.errors!['maxlength'].requiredLength }
        }}
      </mat-error>
    }
    @if (formControlGeneral?.hasError('minlength')) {
      <mat-error>
        {{
          'inputs.minlength'
            | translate: { requiredLength: formControlGeneral?.errors!['minlength'].requiredLength }
        }}
      </mat-error>
    }
    @if (
      formControlGeneral && formControlGeneral.errors && formControlGeneral.errors['errorGeneral']
    ) {
      <mat-error>
        {{ formControlGeneral.errors['errorGeneral'] }}
      </mat-error>
    }
  </mat-form-field>
</div>
